import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Copy, Icon } from '@elparking/components'

import Alert from './Alert'

const Warning = ({ children }) =>
    <Alert>
        <Flex>
            <Box p={0}>
                <Icon type='warning' color='warning' size='large' />
            </Box>
            <Box>
                <Copy padding='0 0 0 1em' fontWeight='book' lineHeight='1.2em'>
                    {children}
                </Copy>
            </Box>
        </Flex>
    </Alert>

Warning.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
}

export default Warning
